import React, { Component } from 'react';
import clazz from 'classnames';
import styles from './index.less';
class Logo extends Component {
    render() {
        const { className, style, collapsed, onClick } = this.props;
        return (<div className={clazz(className, styles.logo, { collapsed })} style={style} onClick={onClick}>
        <img src={require('@/assets/rocket.svg')} alt="" style={{ marginRight: '20px' }}/>
      </div>);
    }
}
export default Logo;
